import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import Button from "../Button";

import b1 from "../../img/Home/back.svg";
import b2 from "../../img/Home/next.svg";

const data = [
  {
    title: "main.15",
    description: "main.16",
    examples: "EUR/USD, GBP/USD, USD/JPY",
  },
  {
    title: "main.17",
    description: "main.18",
    examples: "Apple, Netflix, Microsoft",
  },
  {
    title: "main.19",
    description: "main.20",
    examples: "US100, HK50, GER30",
  },
  {
    title: "main.21",
    description: "main.22",
    examples: "BTCUSD, DOGEUSD, XRPUSD",
  },
  {
    title: "main.23",
    description: "main.24",
    examples: "Gold, Silver, Oil",
  },
];

function TradeWhatEver() {
  const { t } = useTranslation();
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const paginationRef = useRef(null);

  return (
    <div className="relative z-50 pt-[80px] xl:pt-[160px] overflow-hidden">
      <div className="max-w-[1220px] relative xl:mx-auto mx-[20px]">
        <div className="flex flex-col xl:flex-row justify-between">
          {/* Левый блок с текстом */}
          <div className="flex flex-col items-start">
            <p className="xl:max-w-[605px] zen-dots leading-[1.2] text-[24px] xl:text-[36px] text-[#1E1C21]">
              {t("main.11")}
            </p>
            <p className="xl:max-w-[497px] text-[#000000B2] text-[14px] ibm-plex mt-[20px] xl:mt-[40px]">
              {t("main.12")}
            </p>
            <Button className="mt-[40px] xl:mt-[80px]" />
          </div>

          {/* Правый блок со слайдером */}
          <div className="flex flex-col justify-between">
            <div className="mt-[80px] xl:mt-0 xl:w-[497px] h-[220px] md:h-[262px] bg-[#FFFFFF] border border-[#00000033] relative flex flex-col">
              <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                loop={true}
                autoplay={true}
                navigation={{
                  prevEl: prevRef.current,
                  nextEl: nextRef.current,
                }}
                pagination={{
                  el: paginationRef.current,
                  clickable: true,
                }}
                onSwiper={(swiper) => {
                  setTimeout(() => {
                    swiper.params.navigation.prevEl = prevRef.current;
                    swiper.params.navigation.nextEl = nextRef.current;
                    swiper.params.pagination.el = paginationRef.current;

                    swiper.navigation.init();
                    swiper.navigation.update();

                    swiper.pagination.init();
                    swiper.pagination.render();
                    swiper.pagination.update();
                  }, 0);
                }}
                className="w-full h-full"
                breakpoints={{
                    0: {
                        slidesPerView: 1,
                    },
                    768: {
                        slidesPerView: 2,
                    },
                    1280: {
                        slidesPerView: 1,
                    },
                }}
              >
                {data.map((item, index) => (
                  <SwiperSlide key={index}>
                    <div className="px-[20px] md:px-[50px] pt-[35px] md:border-l h-full border-[#00000033] xl:border-none">
                        <h2 className="zen-dots text-[16px] xl:text-[24px]">{t(item.title)}</h2>
                        <p className="ibm-plex text-[12px] xl:text-[14px] mt-[12px]">{t(item.description)}</p>
                        <p className="mt-[12px] ibm-plex text-[12px] xl:text-[14px]">
                            <span className="font-semibold">| {t('main.14')}</span> <span>{item.examples}</span>
                        </p>
                    </div>  
                  </SwiperSlide>
                ))}
              </Swiper>
              <div className="flex items-center justify-between mt-auto border-t border-[#00000033] h-[48px]">
                <div ref={paginationRef} className="pl-[20px] md:pl-[50px] pb-[5px] !w-[200px]"></div>
                <div className="flex">
                    <button ref={prevRef} className="w-[124px] border-l hover:border hover:border-black transition-all h-[48px] border-[#00000033] flex items-center justify-center cursor-my"><img src={b1} alt="" /></button>
                    <button ref={nextRef} className="w-[124px] border-l hover:border hover:border-black transition-all h-[48px] border-[#00000033] flex items-center justify-center cursor-my"><img src={b2} alt="" /></button>
                </div>
              </div>
            </div>
            <p className="xl:max-w-[497px] text-[#000000B2] font-[500] text-[14px] ibm-plex mt-[20px] xl:mt-[40px]">
              {t("main.13")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TradeWhatEver;
